<template>
    <div class="w-full">
        <div>
            <a-form
                :model="searchModel"
                name="horizontal_login"
                layout="inline"
                autocomplete="off"
            >
                <a-form-item
                    :label="langObj['提交时间']"
                    name="status"
                >
                    <a-range-picker v-model:value="searchModel.date"  :disabled-date="disabledDate" @calendarChange="onCalendarChange"/>
                </a-form-item>

                <!-- <a-form-item
                    label="报告类型"
                    name="status"
                    >
                    <a-select
                        v-model:value="searchModel.type"
                        style="width: 220px"
                        allowClear
                    >
                        <a-select-option v-for="(item, index) in typeList" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
                    </a-select>
                </a-form-item> -->

                <a-form-item>
                    <div class="flex items-center">
                        <div @click="reset" class="btn px-5 py-1 fff cursor-pointer ml-4">{{langObj['重置']}}</div>

                        <div @click="search" class="btn px-5 py-1 fff cursor-pointer ml-4" style="background-color: #171325ff;">{{langObj['查询']}}</div>
                        <!-- <div @click="add" class="btn px-5 py-1 fff cursor-pointer ml-4" style="background-color: #171325ff;">{{getLanguage('新建报告')}}</div> -->
                       
                    </div>
                </a-form-item>
                

            </a-form>
        </div>

        <div class="box mt-4" style="width: 100%;">
            <a-table 
            style="width: 100%;" 
            size="small" 
            :row-class-name="getRowClassName" 
            :columns="columns" 
            :data-source="data"
            :pagination="pagination"
            @change="handleTableChange"
            >
                <template #bodyCell="{ column, text, record }">
                    <template v-if="column.dataIndex === 'cycle'">
                        <span>{{ getDate(record.date) }}</span>
                    </template>
                    <template v-if="column.dataIndex === 'cycle2'">
                        <span>{{ getDate2(record.date, record.type) }}</span>
                    </template>
                    <template v-if="column.dataIndex === 'type'">
                        <span>{{ text == 3 ? langObj['周报'] : langObj['月报'] }}</span>
                    </template>
                    <template v-if="column.dataIndex === 'date'">
                        {{ transformLocalDate(text) }}
                    </template>
                    <template v-if="column.dataIndex === 'act'">
                        <!-- <a @click="exportPDF(record)" style="color: #00d1c7ff !important">导出pdf</a>
                        <a-divider type="vertical" /> -->
                        <a @click="details(record)" style="color: #00d1c7ff !important">{{langObj['查看详情']}}</a>
                        <a-divider type="vertical" />
                        <a-popconfirm
                            v-if="admin"
                            :title="langObj['确认删除']+'?'"
                            :ok-text="langObj['确认']"
                            :cancel-text="langObj['取消']"
                            @confirm="deleteReport(record)"
                        >
                            <a style="color: #00d1c7ff !important">{{ langObj['删除'] }}</a>
                        </a-popconfirm>
                    </template>
                </template>
            </a-table>
        </div>


        <!-- 新增报告 -->
        <a-modal
        v-model:visible="visible"
        width="800px"
        title="新增周报"
        :maskClosable="false"
        @ok="sumit"
        > 
            <a-form
            :model="form"
            autocomplete="off"
            :label-col="{ style: { width: '150px' } }"
            >
                <a-form-item
                    label="报告类型"
                    name="type"
                    required
                    >
                    <a-select
                        v-model:value="form.type"
                        style="width: 220px"
                         placeholder="请选择报告类型"
                    >
                        <a-select-option v-for="(item, index) in typeList" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item
                    label="生成时间"
                    name="date"
                    :allowClear="false"
                    required
                    >
                    <a-date-picker show-time v-model:value="form.date" />
                </a-form-item>

            </a-form>
        </a-modal>




    </div>
</template>

<script lang="ts" setup>
import { computed, defineComponent, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import request from "../../common/request";
import { transformDate, transformDate2, transformDate3, getRealFactoryIdList } from "../../common/tools";
import { v4 as uuidv4 } from "uuid";
import { Dayjs } from 'dayjs';
import { langList } from "../../common/lang";
import { getFactoryName, transformBeiJingDate, transformLocalDate } from "../../common/tools";
import { getLanguage, getTranslation, getChineseFt } from "@/common/translate"
import { message } from 'ant-design-vue';

let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
     language.value = 'English'
    langObj.value = langList[language.value]
}
getLang();

const router = useRouter();
const pagination = computed(() => ({
  total: searchModel.value.total,
  current: searchModel.value.skip,
  pageSize: searchModel.value.take,
}));
let searchModel:any = ref({
    date: null,
    type: null,
    total: 0,
    skip: 1,
    take: 10,
    sort: 'date',
    order: -1
})
const columns = [
    {
        title: langObj.value['报告周期'],
        dataIndex: 'cycle',
    },
    {
        title: langObj.value['报告标题'],
        dataIndex: 'title',
    },
    {
        title: langObj.value['报告类型'],
        dataIndex: 'type',
    },
    {
        title: langObj.value['健康设备']+'（台）',
        dataIndex: 'count1',
    },
    {
        title: langObj.value['可用设备']+'（台）',
        dataIndex: 'count2',
    },
    {
        title: langObj.value['警戒设备']+'（台）',
        dataIndex: 'count3',
    },
    {
        title: langObj.value['故障设备']+'（台）',
        dataIndex: 'count4',
    },
    {
        title: langObj.value['分析周期'],
        dataIndex: 'cycle2',
    },
    {
        title: langObj.value['报告时间'],
        dataIndex: 'date',
    },
    {
        title: langObj.value['操作'],
        dataIndex: 'act',
    },
]
let typeList = [
    {label: '周报', value: 3},
    {label: '月报', value: 4},
]
let data:any = ref([])

onMounted(() => {
    init()
})

const init = () => {
    getAdmin()
    search()
}

let admin = ref(false)
const getAdmin = () => {
    let member = JSON.parse(localStorage.getItem('memberInfo') || '')
    admin.value = member?.admin
}


const search = () => {
    searchModel.value.skip = 1
    getData()
}

const reset = () => {
    searchModel.value = {
        ...searchModel.value,
        date: null,
        type: null,
    }
}

const getData = async() => {
    let type = searchModel.value.type ? [searchModel.value.type] : [3, 4]
    let config: any = {
        params: {
            skip: searchModel.value.skip,
            take: searchModel.value.take,
            type,
            sort: searchModel.value.sort,
            order: searchModel.value.order,
            factoryIds: getRealFactoryIdList(),
        },
        headers: {
            requestId: uuidv4(),
        },
    };

    if (searchModel.value.date && searchModel.value.date.length === 2) {
        config.params.begin = transformBeiJingDate(transformDate2(new Date(searchModel.value.date[0]), 1));
        config.params.end = transformBeiJingDate(transformDate2(new Date(searchModel.value.date[1]), 2));
    }

    let result = await request.get('/api/external/reports', config)
    console.log('result', result)

    if(result && result.status === 200) {
        result.data.list.map((d:any) => {
            let count1 = 0, count2 = 0, count3 = 0, count4 = 0
            d.weekReport && d.weekReport.map((i:any) => {
                if(i.status === '故障') {
                    count4 ++
                }
                if(i.status === '警戒') {
                    count3 ++
                }
                if(i.status === '可用') {
                    count2 ++
                }
                if(i.status === '健康') {
                    count1 ++
                }
            })

            d.monthReport && d.monthReport.map((i:any) => {
                if(i.status === '故障') {
                    count4 ++
                }
                if(i.status === '警戒') {
                    count3 ++
                }
                if(i.status === '可用') {
                    count2 ++
                }
                if(i.status === '健康') {
                    count1 ++
                }
            })

            d.count1 = count1
            d.count2 = count2
            d.count3 = count3
            d.count4 = count4

            if(d.title.includes('周报')) {
                if(language.value === 'English') {
                    let lanL = d.title.split('周报')
                    d.title = getTranslation(lanL[0]) + ' weekly report'
                }
            }

            if(d.title.includes('月报')) {
                if(language.value === 'English') {
                    let lanL = d.title.split('月报')
                    d.title = getTranslation(lanL[0]) + ' monthly report'
                }
            }
        })


        data.value = result.data.list
        searchModel.value.total = result.data.count
    }
}

const details = (ev:any) => {
    router.push('/report/mwDetail/' + ev.id)
}



const handleTableChange = (pagination: any, filters: any, sorter: any) => {
  // 处理分页数据
  if(Object.keys(sorter).length) { 
    var order = sorter.order ? (sorter.order == "descend" ? -1 : 1) : 0;
    searchModel.value.sort = sorter.field
    searchModel.value.order = order
  }
  // 处理分页数据
  searchModel.value.skip = pagination.current
  searchModel.value.take = pagination.pageSize
  getData();
};

const getDate = (date: any) => {
  date = new Date(date)
  let year = date.getFullYear()
  let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
//   let w = date.getDay(),
//     d = date.getDate();
//   if (w == 0) {
//     w = 7;
//   }

    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    
    // 计算当前日期与月初的毫秒差
    const diffInMs = date - firstDayOfMonth;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    
    // 获取当月第一天是星期几
    const firstDayOfWeek = firstDayOfMonth.getDay();
    
    // 调整周数计算（假设周一为一周的第一天）
    const weekNumber = Math.ceil((diffInDays + firstDayOfWeek) / 7);



  if(language.value == 'Chinese') {
    return year + '年' + month + '月' + ' ' + '第' + weekNumber + '周'
  } else if(language.value == 'English') {
    let monList = [
        {label: 'January', value: '01'},
        {label: 'February', value: '02'},
        {label: 'March', value: '03'},
        {label: 'April', value: '04'},
        {label: 'May', value: '05'},
        {label: 'June', value: '06'},
        {label: 'July', value: '07'},
        {label: 'August', value: '08'},
        {label: 'January', value: '09'},
        {label: 'October', value: '10'},
        {label: 'November', value: '11'},
        {label: 'December', value: '12'},
    ]
    return monList.find((p:any) => p.value == month)?.label + ' ' + year + ',' + 'Week' + weekNumber
  } else {
    let a = year + '年' + month + '月' + ' ' + '第' + weekNumber + '周'
    return getChineseFt(a)
  }

  
}

const getDate2 = (ev:any, type:any) => {
    let day = type === 3 ? 7 : 30
    let date = new Date(ev).getTime() - (1000 * 60 * 60 * 24 * day)
    let begin = transformDate3(new Date(date))
    return begin + ' ~ ' + transformDate3(ev)
}

const getRowClassName = (record:any, index:any) => {
    // 根据索引设置不同的类名
    return index % 2 === 0 ? 'even-row' : 'odd-row';
}

const dates = ref<any>();

const disabledDate = (current: Dayjs) => {
  if (!dates.value || (dates.value as any).length === 0) {
    return false;
  }
  const tooLate = dates.value[0] && current.diff(dates.value[0], 'days') > 30;
  const tooEarly = dates.value[1] && dates.value[1].diff(current, 'days') > 30;
  return tooEarly || tooLate;
};

const onCalendarChange = (val: any) => {
  dates.value = val;
};

const deleteReport = async(ev:any) => {
    const config = {
        params: {
            id: ev.id
        },
        headers: {
            requestId: uuidv4(),
        },
    };

    let result = await request.delete('/api/reports/info', config)
    if (result?.data) {
        message.success(getLanguage("操作成功"));
        getData();
    } else {
        message.warning("操作失败");
    }
}


// 新增报告
let visible = ref(false)
let form:any = ref({
    type: 3,
    date: null
})

const add = () => {
    form.value = {
        type: 3,
        date: null,
        factoryId: localStorage.getItem('factory_id')
    } 
    visible.value = true
}

const sumit = async() => {
    console.log('form', form.value)//transformDate
    if(!form.value.factoryId) {
        return message.warning('请选择工厂后提交!')
    }
    if(!form.value.date) {
        return message.warning('请选择生成时间后提交!')
    }


    let sub = {
        type: form.value.type,
        factoryId: form.value.factoryId,
        date: transformDate(form.value.date)
    }

    let result = await request.post('/api/reports/week', sub)
}


</script>


<style lang="less" scoped>
.box {
    border: 1px solid #171325ff;
    background: #171325ff;
}

.btn {
    border: 1px solid #171325ff;
    background: #171325ff;
}

.fff {
    color: #fff
}

/deep/ .ant-table-tbody > tr > td {
    border-bottom: 0px solid #fff
}

/deep/ .ant-picker-input > input {
    color: #000000ff;
}

/deep/ .ant-picker-clear span {
    background: #000 !important;
}

/deep/ .ant-drawer-close span svg {
    color: #000 !important;
}
/deep/ .anticon-close svg {
    color: #000 !important;
}

/deep/ .ant-select-clear span {
    background-color: #000;
}
</style>
